import React from 'react';
import { IProps } from './index.types';
import { Container } from './index.style';
import { close, reproveIcon } from '../../../assets';

const ModalError: React.FC<IProps> = ({
  onDismiss = () => {},
  title,
  description
}) => {
  function closeModal() {
    onDismiss();
  }

  return (
    <>
      <Container>
        <button onClick={closeModal}>
          <img src={close} alt="closeIcon" />
        </button>
        <div>
          <img src={reproveIcon} alt="errorIcon" />
          <h3>{title}</h3>
          {typeof description === 'string' ? <p>{description}</p> : description}
        </div>
      </Container>
    </>
  );
};

export default ModalError;
